<div class="flex h-full flex-col items-center gap-4 p-4 rounded my-auto" *transloco="let t">
  <sky-empty [fontIcon]="icon() || 'do_disturb_on'" [scope]="'error.not_found'" [hideSubHeader]="true">
    @if (message()) {
      <span class="text-sm font-normal text-center mb-2">{{ message() }}</span>
    }
    <button mat-flat-button color="primary" (click)="onRetry()">
      <mat-icon class="text-white">refresh</mat-icon>
      <span>{{ t('buttons.retry') }}</span>
    </button>
  </sky-empty>
</div>
